// Types
import * as Types from './types'
import {successGenerate} from '../common'
import { IDeleteModal, IQuestionDetailModal, IStoryReadingModalModel, IStudentDetailModal } from "../../constants";

const actionDeleteModalOpen = (data:IDeleteModal) => ({
  type: successGenerate(Types.DELETE_MODAL_OPEN),
  payload: {data: data},
})

const actionDeleteModalClose = () => ({
  type: successGenerate(Types.DELETE_MODAL_CLOSE),
})

const actionStoryReadingModalOpen = ( data: IStoryReadingModalModel) => ({
  type: successGenerate(Types.STORY_READING_MODAL_OPEN),
  payload: {data: data},
})

const actionStoryReadingModalClose = () => ({
  type: successGenerate(Types.STORY_READING_MODAL_CLOSE),
})

const actionStoryDetailModalOpen = ( data: IStoryReadingModalModel) => ({
  type: successGenerate(Types.STORY_DETAIL_MODAL_OPEN),
  payload: {data: data},
})

const actionStoryDetailModalClose = () => ({
  type: successGenerate(Types.STORY_DETAIL_MODAL_CLOSE),
})


const actionStudentDetailModalOpen = ( data: IStudentDetailModal) => ({
  type: successGenerate(Types.STUDENT_DETAIL_MODAL_OPEN),
  payload: {data: data},
})

const actionStudentDetailModalClose = () => ({
  type: successGenerate(Types.STUDENT_DETAIL_MODAL_CLOSE),
})
const actionQuestionDetailModalOpen = ( data: IQuestionDetailModal) => ({
  type: successGenerate(Types.QUESTION_DETAIL_MODAL_OPEN),
  payload: {data: data},
})

const actionQuestionDetailModalClose = () => ({
  type: successGenerate(Types.QUESTION_DETAIL_MODAL_CLOSE),
})

// Export
export {
  actionStudentDetailModalClose,
  actionStoryDetailModalOpen,
  actionDeleteModalOpen,
  actionDeleteModalClose,
  actionStoryDetailModalClose,
  actionStudentDetailModalOpen,
  actionStoryReadingModalClose,
  actionStoryReadingModalOpen,
  actionQuestionDetailModalOpen,
  actionQuestionDetailModalClose
}
